import { modalsStore } from 'stores/modalStore';
import {
  BranchModalData,
  CaseModalData,
  CreateOrderModalData,
  GeneralModalData,
  MaterialModalData,
  NewsModalData,
  OrderModalData,
  TaskModalData,
  UpdateUserModalData,
} from 'types/modalDataTypes';

export const MODAL_ID = {
  MATERIAL_DOWNLOAD: 'material.download',
  CREATE_ORDER_GENERAL_INFORMATION_EDIT_ADDRESS: 'create.order.general.information.edit.address',
  CREATE_ORDER_GENERAL_INFORMATION_EDIT_ADDRESS_KEY_PICK_UP:
    'create.order.general.information.edit.address.key.pick.up',
  CREATE_ORDER_GENERAL_INFORMATION_EDIT_ADDRESS_END_UER_INVOICE:
    'create.order.general.information.edit.address.end.user.invoice',
  CREATE_ORDER_GENERAL_INFORMATION_EDIT_ADDRESS_BUSINESS_INVOICE:
    'create.order.general.information.edit.address.business.invoice',
  CREATE_ORDER_COPYRIGHT_INFORMATION: 'create.order.copyright.information',
  CREATE_ORDER_WARN_PROPERTY_SIZE: 'create.order.warn.property.size',

  //cases
  CASES_MATERIALS_DOWNLOAD: 'cases.materials.download',
  CASES_ASSETS_SHOW_FILE: 'cases.assets.show.file',
  CASES_COPY_ASSETS: 'cases.copy.assets',
  ARCHIVE_MATERIAL: 'archive.material',
  RECREATE_MATERIALS: 'recreate.materials',
  REMOVE_BATCH_MATERIALS: 'remove.batch.materials',
  CREATE_COLLAGE: 'create.collage',
  TEXT_DOCUMENT: 'text.document',
  EDIT_ADDRESS_MANUALLY: 'edit.address.manually',

  //orders
  ADD_ORDER_LINE: 'add.order.line',
  ADD_FEEDBACK_ON_ORDER_LINE: 'add.feedback.on.order.line',
  ORDER_SHOW_MATERIAL: 'order.show.material',
  TEXT_TASK_NOTES: 'text.task.notes',

  //materials
  COPY_MATERIAL_BY_CASE_LOCATION: 'copy.material.by.case.location',
  ADD_NEW_DOCUMENT_MATERIAL: 'add.new.document.material',
  ADD_NEW_LINK_MATERIAL: 'add.new.link.material',
  DELETE_DOCUMENT_MATERIAL: 'delete.document.material',
  DELETE_LINK_MATERIAL: 'delete.link.material',

  //general
  GLOBAL_SEARCH: 'global.search',

  USER_INVITATION: 'user.invite',
  USER_UPDATE: 'user.update',

  //BRANCH
  ADD_EDIT_SOCIAL_MEDIA_ACCOUNT: 'add.edit.social.media.account',
  DELETE_SOCIAL_MEDIA_ACCOUNT: 'delete.social.media.account',

  //NEWS
  NEWS: 'news',
} as const;

export const TASKS_MODAL_ID = {
  ARIAL: 'task.arial',

  /*combine BASIC and BASIC_OPT into INPUTTEXT*/
  BASIC: 'task.basic',
  BASIC_OPT: 'task.basicopt',
  INPUT_TEXT: 'task.input.text',
  /*combine BASIC and BASIC_OPT into INPUTTEXT*/

  COMTEXT: 'task.comtext',
  COMBINE_IMAGES: 'task.combineImages', //this task is not available on prod env
  COPYWRITE_TEXTS: 'task.copywrite.texts',
  INTRO_OUTRO: 'task.intro.and.outro',
  INTRO_OUTRO_SPEAK: 'task.intro.and.outro.speak',
  LOCATION: 'task.location', //this task is not available on prod env

  /*combine TEXT and TEXT-STYLE into TEXT */
  TEXT: 'task.text',
  'TEXT-STYLE': 'task.no.style.text',
  /*combine TEXT and TEXT-STYLE into TEXT */

  PERSON: 'task.person',
  PERSON_INFO: 'task.person.info',
  SOCIAL_MEDIA: 'task.social.media',
  SOCIAL_MEDIA_SLIDESHOW: 'task.social.media.slideshow',
  SPEAK_INPUT: 'task.speak.input',

  /*combine UPLOAD_IMAGES and UPLOAD_VIDEOS into UPLOAD*/
  UPLOAD_IMAGES: 'task.upload.images',
  UPLOAD_VIDEOS: 'task.upload.videos',
  UPLOAD: 'task.upload',
  /*combine UPLOAD_IMAGES and UPLOAD_VIDEOS into UPLOAD*/

  VIDIBILI_COMMENT: 'task.vidibili.comment',

  VIRTUAL_STAGING_INDOOR_RENOVATION: 'task.virtual.staging.indoor.renovation',
  VIRTUAL_STAGING_REMOVE_OBJECTS: 'task.virtual.staging.remove.objects',
  BOOK_PHOTOGRAPHER: 'task.book.photographer',
  VIRTUAL_STAGING_OUTDOOR_RENOVATION: 'task.virtual.staging.outdoor.renovation',
  RETOUCHING_IMAGE: 'task.retouching.image',

  /*combine IMAGE_SELECTOR and WHITEBOX_IMAGE_SELECTOR into IMAGE_SELECTORS */
  WHITEBOX_IMAGE_SELECTOR: 'task.virtual.staging.remove.objects',
  IMAGE_SELECTOR: 'task.image.selector',
  IMAGE_SELECTORS: 'task.image.selectors',
  /*combine IMAGE_SELECTOR and WHITEBOX_IMAGE_SELECTOR into IMAGE_SELECTORS */

  /* combine SOCIAL_MEDIA_GIF and BEFORE_AFTER into BEFORE_AFTER */
  SOCIAL_MEDIA_GIF: 'task.social.media.gif',
  BEFORE_AFTER: 'task.before.and.after',
  /* combine SOCIAL_MEDIA_GIF and BEFORE_AFTER into BEFORE_AFTER */

  /* combine VIRTUAL_STAGING and VIRTUAL_STAGING_COMMERCIAL.. into VIRTUAL_STAGING_PICTURE */
  VIRTUAL_STAGING: 'task.virtual.staging',
  VIRTUAL_STAGING_COMMERCIAL: 'task.virtual.staging.commercial',
  VIRTUAL_STAGING_COMMERCIAL_720: 'task.virtual.staging.commercial.720',
  VIRTUAL_STAGING_720: 'task.virtual.staging.720',
  VIRTUAL_STAGING_PICTURE: 'task.virtual.staging.picture',
  /* combine VIRTUAL_STAGING and VIRTUAL_STAGING_COMMERCIAL into VIRTUAL_STAGING_PICTURE */
  AITextInput: 'task.AI.text.input',
  AITextOverview: 'task.AI.text.overview',
};

export const MODALS_STORE = {
  //general
  general: modalsStore<GeneralModalData>(),

  //orders
  orders: modalsStore<OrderModalData>(),
  createOrder: modalsStore<CreateOrderModalData>(),

  //tasks
  tasks: modalsStore<TaskModalData>(),

  userUpdate: modalsStore<UpdateUserModalData>(),
  userInvitation: modalsStore<void>(),

  //cases
  cases: modalsStore<CaseModalData>(),

  //materials
  materials: modalsStore<MaterialModalData>(),

  //branch
  branch: modalsStore<BranchModalData>(),

  news: modalsStore<NewsModalData>(),
};
